import {dictionary, locale, _ } from 'svelte-i18n';

import it from './i18n/it.json';
// console.log(it);

function setupI18n({withLocale: _locale} = { withLocale: 'it'}) {
    dictionary.set({it: it});
    locale.set(_locale);
}

export { setupI18n, _ };